import React from 'react';
import { Button } from '@ghq-abi/design-system-v2';
import { ListFilter } from 'lucide-react';

import { cn } from '~/lib/utils';

import { SEARCH_BAR_STYLES } from '../constants';

interface FilterButtonProps {
  text?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  text = 'Filters',
  onClick,
  disabled = false,
  className
}) => {
  return (
    <div className={cn(SEARCH_BAR_STYLES.BUTTON_CONTAINER, className)}>
      <Button
        variant="secondary"
        size="sm"
        border="default"
        onClick={onClick}
        disabled={disabled}
        className="flex items-center">
        <div className="flex-shrink-0 mr-2">
          <ListFilter className="w-4 h-4" />
        </div>
        <span className="text-sm">{text}</span>
      </Button>
    </div>
  );
};
